webpackJsonp([49683490770531],{

/***/ 633:
/***/ (function(module, exports) {

	module.exports = {"data":{"allContentfulPost":{"edges":[{"node":{"title":"Hello World","id":"JwstF8v2ayIYuw6cAMY2a","slug":"hello-world","heroImage":{"title":"test-image","sizes":{"aspectRatio":1.3333333333333333,"src":"//images.ctfassets.net/35zg833hp858/39Fdzox3JueSW8eeckOmKc/f8dd7dbd2834eaeedd01c93b63aaff46/test-image.jpg?w=1800&q=50","srcSet":"//images.ctfassets.net/35zg833hp858/39Fdzox3JueSW8eeckOmKc/f8dd7dbd2834eaeedd01c93b63aaff46/test-image.jpg?w=450&h=338&q=50 450w,\n//images.ctfassets.net/35zg833hp858/39Fdzox3JueSW8eeckOmKc/f8dd7dbd2834eaeedd01c93b63aaff46/test-image.jpg?w=900&h=675&q=50 900w,\n//images.ctfassets.net/35zg833hp858/39Fdzox3JueSW8eeckOmKc/f8dd7dbd2834eaeedd01c93b63aaff46/test-image.jpg?w=1000&h=750&q=50 1000w","sizes":"(max-width: 1800px) 100vw, 1800px"}},"abstract":{"abstract":"Greetings, welcome to my blog."},"body":{"childMarkdownRemark":{"html":"<p>Lorem ipsum</p>"}},"publishDate":"2018-03-08T00:00"}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-42badc690d242d788dfd.js